/*
* The script here are defined to be used in multiple js files
*
* reusable function script goes here
*
*/
jQuery(document).ready(function($) {
    
    /*********************** 
     * scroll to section 
     **********************/
    UpdateAccountScrollToSection = (className, height) => {
        width = window.screen.width;
        let destination = $(className).offset().top - height;
        $('html,body').animate({ scrollTop: destination }, "slow");
        if(width<992) {
        } else {
            // $("html, body").animate({ scrollTop: 0 }, "slow");
        }
    }

    /*********************** 
     * ajax loader show
     **********************/
    ajaxLoaderShow = () => {
        $('.loading').addClass('full-loading');
    }
        
    /*********************** 
     * ajax loader hide
     **********************/
    ajaxLoaderHide = () => {
    	$('.loading').removeClass('full-loading');
    }

    /*********************** 
     * ajax loading
     **********************/
    ajaxLoading = () => {
        return '<div class="loader btn-loading w-100"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 0C4.824 0 0.553781 3.954 0.0507812 9H2.06836C2.56336 5.06 5.928 2 10 2C14.072 2 17.4366 5.06 17.9316 9H19.9492C19.4452 3.954 15.176 0 10 0ZM0.0507812 11C0.250781 13.008 1.05458 14.8374 2.26758 16.3184L3.6875 14.8984C2.8295 13.7924 2.25136 12.457 2.06836 11H0.0507812ZM16.2715 14.9297C15.8575 15.4547 15.3855 15.9328 14.8555 16.3398L15.8672 18.0742C16.6802 17.4832 17.399 16.7698 18.002 15.9668L16.2715 14.9297ZM5.10352 16.3105L3.68164 17.7324C4.98764 18.8014 6.56592 19.5496 8.29492 19.8516L8.4375 17.8398C7.2005 17.5918 6.06452 17.0595 5.10352 16.3105ZM13.1309 17.3516C12.2949 17.7086 11.3846 17.9285 10.4316 17.9805L10.2891 19.9863C11.6611 19.9473 12.9606 19.621 14.1406 19.082L13.1309 17.3516Z" fill="#385CDD" /></svg></div>';
    }

    /*********************************** 
     * no share feature for instagram
     **********************************/
    $('.resp-sharing-button__link-no-action').on('click', function (e) {
        e.preventDefault();
    })

    /********************************** 
     * ad active class in parent li
     *********************************/
    $('.nav-item.menu-with-icon.active').each(function() {
        // Add active class to the closest parent with .menu-item-has-children
        $(this).closest('.menu-item-has-children').addClass('active');
    });

    // $('#gform_submit_button_3').after('<img id="gform_ajax_spinner_6" class="gform_ajax_spinner" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7">');

    /*************************************** 
     * blog detail sidebar color on click
     **************************************/
    document.querySelectorAll('.wp-block-rank-math-toc-block li a').forEach(item => {
        item.addEventListener('click', function() {
            // Save the original color
            let originalColor = this.style.color;

            // Change the color on click
            this.style.color = '#4c00cf';

            // After 2 seconds, revert to the original color
            setTimeout(() => {
                this.style.color = originalColor;
            }, 3500);
        });
    });
});